import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { fetchClinicas, fetchPacientes } from '../../services/firebaseService';

function FiltroRelatorios({
  setClinica,
  setPaciente,
  setDataInicio,
  setDataFim,
}) {
  const [clinicas, setClinicas] = useState([]);
  const [pacientes, setPacientes] = useState([]);
  const [loading, setLoading] = useState(true); // Estado de carregamento
  const [error, setError] = useState(null); // Estado de erro

  useEffect(() => {
    async function loadClinicasEPacientes() {
      try {
        const clinicasData = await fetchClinicas();
        setClinicas(clinicasData);
        const pacientesData = await fetchPacientes();
        setPacientes(pacientesData);
        setLoading(false); // Desativa o carregamento após os dados serem carregados
      } catch (error) {
        setError('Erro ao carregar clínicas e pacientes.'); // Define a mensagem de erro
        console.error('Erro ao carregar clínicas e pacientes:', error.message);
        setLoading(false); // Desativa o carregamento mesmo com erro
      }
    }

    loadClinicasEPacientes();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-24">
        <div className="loader ease-linear rounded-full border-8 border-t-8 border-gray-200 h-16 w-16"></div>
        <p className="ml-4 text-gray-600 text-lg">Carregando...</p>
      </div>
    ); // Indicador de carregamento com um spinner
  }

  if (error) {
    return (
      <div className="bg-red-100 text-red-700 p-4 rounded-md">
        <p>{error}</p>
      </div>
    ); // Exibe a mensagem de erro em um banner
  }

  return (
    <div className="filtro-relatorios bg-white p-6 mb-6 rounded-xl shadow-lg">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label
            htmlFor="clinica"
            className="block text-sm font-semibold text-gray-700"
          >
            Clínica
          </label>
          <select
            id="clinica"
            onChange={(e) => setClinica(e.target.value)}
            className="mt-2 block w-full p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            aria-label="Selecione uma clínica"
          >
            <option value="">Todas as Clínicas</option>
            {clinicas.map((clinica) => (
              <option key={clinica.id} value={clinica.id}>
                {clinica.nome}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label
            htmlFor="paciente"
            className="block text-sm font-semibold text-gray-700"
          >
            Paciente
          </label>
          <select
            id="paciente"
            onChange={(e) => setPaciente(e.target.value)}
            className="mt-2 block w-full p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            aria-label="Selecione um paciente"
          >
            <option value="">Todos os Pacientes</option>
            {pacientes.map((paciente) => (
              <option key={paciente.id} value={paciente.id}>
                {paciente.nome}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label
            htmlFor="dataInicio"
            className="block text-sm font-semibold text-gray-700"
          >
            Data Início
          </label>
          <input
            type="date"
            id="dataInicio"
            onChange={(e) => setDataInicio(e.target.value)}
            className="mt-2 block w-full p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            aria-label="Selecione a data de início"
          />
        </div>

        <div>
          <label
            htmlFor="dataFim"
            className="block text-sm font-semibold text-gray-700"
          >
            Data Fim
          </label>
          <input
            type="date"
            id="dataFim"
            onChange={(e) => setDataFim(e.target.value)}
            className="mt-2 block w-full p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            aria-label="Selecione a data de fim"
          />
        </div>
      </div>
    </div>
  );
}
FiltroRelatorios.propTypes = {
  setClinica: PropTypes.func.isRequired,
  setPaciente: PropTypes.func.isRequired,
  setDataInicio: PropTypes.func.isRequired,
  setDataFim: PropTypes.func.isRequired,
};

export default FiltroRelatorios;
